module.exports = __webpack_public_path__ + "img/icon-circle-success-green.89118a1e.svg";